var View = require('views/base/view');
import { KeybindingService, keys } from 'services/keybinding-service';
var LocaleService = require('services/locale-service');
var MenuView = require('views/menu/menu-view');
var CssView = require('views/css/css-view');
var CompatibilityView = require('views/compatibility/compatibility-view');
var ContentService = require('services/content-service');
import { SessionStorageService } from 'services/web-storage-service';
var CourseSettingsService = require('services/course-settings-service');
var Menu = require('models/menu');
var ContentProvider = require('services/content-provider');

import DeveloperToolbarView from 'developer/views/toolbar/toolbar-view';
import GuidesOverlayView from 'developer/views/toolbar/guides-overlay-view';

const { Tab } = keys;

var SiteView = View.extend({
  container: 'body',
  id: 'site-container',
  regions: {
    main: '#main-container',
    compatibility: '.site-compatibility',
    portfolio: '.site-portfolio',
    devbar: '.developer-toolbar',
    css: '.css'
  },
  listen: {
    'audio:play:failed mediator': 'playFailed',
    'media:status:changed mediator': 'audioPlaying'
  },
  template: require('./templates/site'),
  className() {
    return [EF.enrollment.get('demoMode') ? 'preview' : 'not-preview',
    this.model.get('progressProvider')].join(' ');
  },
  initialize: function() {
    this.on('addedToDOM', this.addEventDelegates);
    this.refresh();
    if(SessionStorageService.getItem('overlayEnabled') === true) {
      let guidesOverlayView = new GuidesOverlayView();
      guidesOverlayView.render();
    }
    View.prototype.initialize.apply(this, arguments);
  },
  refresh: function() {
    this.$el.attr('data-controller', this.model.get('controller'));
  },
  addEventDelegates: function() {
    const self = this;
    $('body').addClass('sdk-loaded');
    ContentProvider.SiteService.addSponsorClass();
    if(CourseSettingsService.get('disableBranding')) {
      $('body').addClass('no-branding');
    }
    $('#site-container').addClass(LocaleService.getLanguage() + ' focus-hide');

    this.delegate('keydown', function(e) {
      if($(e.target).prop('tagName') !== 'INPUT') {
        KeybindingService.with(e).bind(Tab, () => {
          $('#site-container').removeClass('focus-hide')
          $('body').removeClass('focus-hide')
        });
      }
    });

    this.delegate('click', '#portfolio_button', function(e) {
      e.preventDefault();

      if(this.portfolioShowing) {
        this.closePortfolio();
      } else {
        Chaplin.mediator.publish('action:pause');
        //Store the current page's namespace, so when the portfolio is closed it can be restored
        this.localeNamespace = LocaleService.currentNamespace();
        this.$('#portfolio_button').addClass('open').html(LocaleService.t('portfolioButtonOpen'));

        const menuSettings = CourseSettingsService.get('menu');
        const menu = new Menu(menuSettings);
        const menuKey = menuSettings.portfolioPage;
        menu.set('key', menuKey);
        ContentService.applyContentAndLocale(menu, 'menu.' + menuKey)
          .then(model => {
            const menuView = new MenuView({
              className: menuKey,
              model: model,
              region: 'portfolio'
            });
            menuView.container.focus();
            this.listenTo(menuView, 'close', this.closePortfolio);
            this.subview('portfolio', menuView);
            this.portfolioShowing = true;
          });
      }
    });

    this.delegate('click', '#developer_button', function(e) {
      e.preventDefault();

      if(this.devBarShowing) {
        $('.developer-toolbar').hide();
        this.subviewsByName.devBar.dispose();
      } else {
        var devBarView = new DeveloperToolbarView({
          region: 'devbar'
        });

        this.subview('devBar', devBarView);
        $('.developer-toolbar').show();
        devBarView.delegate('click', '[data-close]', function() {
          $('.developer-toolbar').hide();
          self.subviewsByName.devBar.dispose();
          self.devBarShowing = false;
        });
      }
      this.devBarShowing = !this.devBarShowing;

    });
    this.delegate('click', '#start_audio', () => {
      if(createjs.WebAudioPlugin.context && createjs.WebAudioPlugin.context.state === 'suspended') {
        createjs.WebAudioPlugin.context.resume().then(() => {
          Chaplin.mediator.publish('audio:play:' + this.audioId);
          this.$('#audio-starter').hide();
        });
      } else {
        Chaplin.mediator.publish('audio:play:' + this.audioId);
        this.$('#audio-starter').hide();
      }
    });
    if(this.model.get('cssTemplate')) {
      var cssView = new CssView({
        model: EF.customizations.findByType('css-customization'),
        template: this.model.get('cssTemplate'),
        region: 'css'
      });
      this.subview('cssView', cssView);
    }
    if(CourseSettingsService.get('showCompatibilityWarning') && !SessionStorageService.getItem('compatibility-closed')) {
      var compatView = new CompatibilityView({
        model: this.model,
        region: 'compatibility'
      });
      compatView.delegate('click', '[data-close]', function() {
        SessionStorageService.setItem('compatibility-closed', true);
        $('.site-compatibility').hide();
        if(self.subviewsByName && self.subviewsByName.compatibility) {
          self.subviewsByName.compatibility.dispose();
        }
      });
      this.subview('compatibility', compatView);
    }
  },
  closePortfolio() {
    //The portfolio is being closed. Restore the page's locale namespace, so translations will still be applied correctly
    LocaleService.addDefaultResources(this.localeNamespace);
    Chaplin.mediator.publish('action:resume');
    if(this.subviewsByName.portfolio) {
      this.subviewsByName.portfolio.dispose();
    }
    this.$('#portfolio_button').removeClass('open').html(LocaleService.t('portfolioButton'));

    this.portfolioShowing = false;
    this.$('#portfolio_button').focus();
  },
  playFailed: function(audioId) {
    this.$('#audio-starter').show();
    this.$('#audio-starter').attr('tabindex', '0').focus();
    this.audioId = audioId;
  },
  audioPlaying: function(status, _audioId) {
    if(status === 'playing') {
      this.$('#audio-starter').hide();
    }
  }
});

module.exports = SiteView;
